import { useRef, useEffect, useState } from 'react';

import { ReactComponent as LeftArrow } from '@assets/icons/crm/leftArrrow.svg';
import { ReactComponent as RightArrow } from '@assets/icons/crm/rightArrow.svg';

import CommonImage from '@/components/CommonImage';
import { Task_PRIORITY_OPTIONS } from '@/features/my-dashborad/utils';
import {
	useGetBuyerFeedbackMutation,
	useGetFabricStatusMutation
} from '@/features/my-dashborad/api/myDashboardApi';
import { toastSuccess, toastError } from '@/components/Toast';

const SampleJourneyList = ({
	listViewResponse,
	onClickDesignImage,
	handleSelectSampleItem,
	handleSelectAllSampleItem,
	selectedSampleItem,
	handleUpdatePriority,
	handleGetRemarks,
	isUpdatingRemarks
}) => {
	const elementRef = useRef(null);
	const [arrowDisable, setArrowDisable] = useState(true);
	const [rightArrowDisable, setRightArrowDisable] = useState(false);

	const [getBuyerFeedback, { isLoading: isUploadingFeedbackLoading }] = useGetBuyerFeedbackMutation();
	const [getFabricStatus, { isLoading: isUploadingFabric }] = useGetFabricStatusMutation();
	//arrow buttons
	const updateButtonStates = (element) => {
		if (!element) return;

		const isAtStart = element.scrollLeft === 0;
		const isAtEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 1;

		setArrowDisable(isAtStart);
		setRightArrowDisable(isAtEnd);
	};
	const handleHorizontalScroll = (element, speed, distance, step) => {
		if (!element) return;

		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}
			// Update button states during scroll
			updateButtonStates(element);
		}, speed);
	};

	useEffect(() => {
		const scrollElement = elementRef.current;
		if (!scrollElement) return undefined;

		updateButtonStates(scrollElement);

		// Keep arrow state in sync with user-driven horizontal scroll.
		const handleScroll = () => updateButtonStates(scrollElement);
		scrollElement.addEventListener('scroll', handleScroll);

		return () => {
			scrollElement.removeEventListener('scroll', handleScroll);
		};
	}, []);

	///buyerfeedback
	const handleGetBuyerFeedback = async (item, feedbackValue) => {
		const prevFeedback = item?.inHouseDevelopmentJourneyDetails?.buyerFeedback ?? '';
		if (prevFeedback === feedbackValue) return;
		try {
			await getBuyerFeedback({
				id: item?.inHouseDevelopmentJourneyDetails?.sampleItemId,
				buyerFeedback: feedbackValue
			}).unwrap();
			toastSuccess('Buyer feedback updated successfully');
		} catch ({ error }) {
			toastError(error?.data?.message || 'Something went wrong');
		}
	};

	//fabricstuatus
	const handleFabricStatus = async (item, fabricStatus) => {
		const prevFabricStatus = item?.inHouseDevelopmentJourneyDetails?.fabricStatus;
		if (prevFabricStatus === fabricStatus) return;

		try {
			await getFabricStatus({
				id: item?.inHouseDevelopmentJourneyDetails?.sampleItemId,
				fabricStatus: fabricStatus
			}).unwrap();
			toastSuccess('Fabric status updated successfully');
		} catch ({ error }) {
			toastError(error?.data?.message || 'Something went wrong');
		}
	};

	const PriorityDropdown = ({ priority, productItemData, handleUpdatePriority }) => (
		<div className="option">
			<div className="dropdown">
				<button
					aria-expanded="false"
					className="btn btn-default dropdown-toggle"
					data-toggle="dropdown"
					id="menu1"
					type="button"
				>
					<span
						className={`mr-2 status yellow-1 status-with-border  ${Task_PRIORITY_OPTIONS[priority]}`}
					>
						{priority || 'Select priority'}
					</span>
					<CommonImage
						className="arrow-icon"
						src="/icons/down-arrow-gray-dark-01.svg"
						width={20}
						height={20}
					/>
				</button>
				<ul
					aria-labelledby="menu1"
					className="dropdown-menu dropdown-menu-right shadow-lg"
					role="menu"
					x-placement="bottom-end"
				>
					{Task_PRIORITY_OPTIONS?.map((tag) => (
						<li
							key={tag.value}
							className="px-4 pb-3 pt-3"
							role="presentation"
							onClick={() =>
								handleUpdatePriority({
									...productItemData,
									taskPriority: tag.value
								})
							}
						>
							<span
								className={`font-weight-normal ${tag.className}`}
								role="menuitem"
								tabIndex={-1}
							>
								{tag?.name}
							</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);

	const renderSampleJourneyListRow = (item, idx) => {
		return (
			<tr key={`${item.id}_${idx}`}>
				<td className="checkbox-column">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input
								type="checkbox"
								id={`${item?.id}-${idx}`}
								name={`sample_${item?.id}`}
								value={item?.id}
								onChange={(e) => handleSelectSampleItem(e, item)}
								checked={selectedSampleItem.includes(parseInt(item?.id))}
							/>
							<label htmlFor={`${item?.id}-${idx}`} />
						</div>
					</div>
				</td>
				<td className="image-column cursor-pointer" onClick={() => onClickDesignImage(item?.id)}>
					<div className="d-flex align-items-center justify-content-center">
						<img src={item.designDocuments?.[0]?.docUrl} alt="" className="cell-img pr-2" />
					</div>
				</td>
				<td className="ref-column">
					<p className="regular-14  gray_dark_02 mb-0">{item?.systemReferenceNumber}</p>
				</td>
				<td className="style-details-column">
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.productGroup}-{item?.mainFabricType}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">{item?.subCategory}</p>
					<p className="regular-14  gray_dark_02 mb-0">{item?.addedByName}</p>
				</td>
				<td className="brand-column">
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.inHouseDevelopmentJourneyDetails?.brandResponse?.name}
					</p>
				</td>
				<td className="request-column">
					<p className="mb-0">
						<span
							className="regular-14 text-underline gray_dark_01 cursor-pointer"
							onClick={() =>
								window.open(
									`/sample/view/${item?.inHouseDevelopmentJourneyDetails?.requestId}`,
									'_blank'
								)
							}
						>
							{item?.collectionName}
						</span>
					</p>
				</td>
				<td className="po-request-column">
					<p className="regular-14  gray_dark_02 mb-0">
						Send to PD:{item?.inHouseDevelopmentJourneyDetails?.sendToPdDate},
						{item?.inHouseDevelopmentJourneyDetails?.sendToPdByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						Received:{item?.inHouseDevelopmentJourneyDetails?.pdReceivedDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.pdReceivedByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						GT review: {item?.inHouseDevelopmentJourneyDetails?.gtReviewDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.gtReviewByName}
					</p>
				</td>
				<td className="planned-vs-actual-column">
					<p className="regular-14  gray_dark_02 mb-0">
						Required:{item?.inHouseDevelopmentJourneyDetails?.requiredDate}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						Planned: {item?.inHouseDevelopmentJourneyDetails?.plannedDate}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						Actual H/O: {item?.inHouseDevelopmentJourneyDetails?.actualHandoverDate}
					</p>
				</td>
				<td className="l-d-status-column">
					<div>
						<span className="status yellow-1 status-with-border d-inline-block mb-1">
							{item?.inHouseDevelopmentJourneyDetails?.lastStatusName}
						</span>
						<p className="regular-14 gray_dark_02 mb-0">
							{item?.inHouseDevelopmentJourneyDetails?.lastStatusDate}
						</p>
						<p className="regular-14 gray_dark_02 mb-0">
							by {item?.inHouseDevelopmentJourneyDetails?.lastStatusByName}
						</p>
					</div>
				</td>
				<td className="qc-lead-time-column">
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.inHouseDevelopmentJourneyDetails?.qcLeadTime}D
					</p>
				</td>
				<td className="actual-lead-time-column">
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.inHouseDevelopmentJourneyDetails?.actualLeadTime}D
					</p>
				</td>
				<td className="plan-lead-time-column">
					{(() => {
						const planned = item?.inHouseDevelopmentJourneyDetails?.plannedLeadTime ?? 0;
						const actual = item?.inHouseDevelopmentJourneyDetails?.actualLeadTime ?? 0;
						const variance = actual - planned;
						return (
							<>
								<p className="regular-14  gray_dark_02 mb-0">
									{planned}D (
									<span className="regular-14  gray_dark_02 mb-0">{variance}</span>)
								</p>
								{variance > 0 ? (
									<span className="status red-3 status-with-border">Delay</span>
								) : (
									<span className="status green-3 status-with-border">On Time</span>
								)}
							</>
						);
					})()}
				</td>
				<td className="required-lead-time-column">
					{(() => {
						const req = item?.inHouseDevelopmentJourneyDetails?.requiredLeadTime ?? 0;
						const actual = item?.inHouseDevelopmentJourneyDetails?.actualLeadTime ?? 0;
						const variance = actual - req;
						return (
							<>
								<p className="regular-14  gray_dark_02 mb-0">
									{req}D (<span className="regular-14  gray_dark_02 mb-0">{variance}</span>)
								</p>
								{variance > 0 ? (
									<span className="status red-3 status-with-border">Delay</span>
								) : (
									<span className="status green-3 status-with-border">On Time</span>
								)}
							</>
						);
					})()}
				</td>
				<td className="pending-issue-column">
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.inHouseDevelopmentJourneyDetails?.pendingIssueCount}
					</p>
				</td>
				<td className="priority-column">
					<PriorityDropdown
						priority={item?.inHouseDevelopmentJourneyDetails?.taskPriority}
						productItemData={item}
						handleUpdatePriority={handleUpdatePriority}
					/>
				</td>
				<td className="graphics-column">
					<p>
						<span>
							Request : {item?.inHouseDevelopmentJourneyDetails?.graphicsRequestDate},{' '}
							{item?.inHouseDevelopmentJourneyDetails?.graphicsRequestByName}
						</span>
						<span>
							Complete: {item?.inHouseDevelopmentJourneyDetails?.graphicsCompletedDate},{' '}
							{item?.inHouseDevelopmentJourneyDetails?.graphicsCompletedByName}
						</span>
					</p>
				</td>
				<td className="3d-column">
					<p>
						Request : {item?.inHouseDevelopmentJourneyDetails?.threedRequestDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.threeDRequestByName}
					</p>
					<p>
						Complete: {item?.inHouseDevelopmentJourneyDetails?.threeDCompletedDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.threeDCompletedByName}
					</p>
				</td>
				<td className="pattern-cutting-complete-column">
					<p className="regular-14  gray_dark_02 mb-0">
						Pattern: {item?.inHouseDevelopmentJourneyDetails?.patternCompleteDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.patternCompleteByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						3D Pattern:{item?.inHouseDevelopmentJourneyDetails?.threeDPatternCompleteDate},
						{item?.inHouseDevelopmentJourneyDetails?.threeDPatternCompleteByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						Cutting: {item?.inHouseDevelopmentJourneyDetails?.cuttingCompleteDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.cuttingCompleteByName}
					</p>
				</td>
				<td className="print-column">
					<p className="regular-14  gray_dark_02 mb-0">
						-Rec print:{item?.inHouseDevelopmentJourneyDetails?.printReceivedDate}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						-{item?.inHouseDevelopmentJourneyDetails?.printTypes?.join(', ')}
					</p>
				</td>
				<td className="embo-column">
					<p className="regular-14  gray_dark_02 mb-0">
						-Rcv Embo: {item?.inHouseDevelopmentJourneyDetails?.emboReceivedDate},
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						-{item?.inHouseDevelopmentJourneyDetails?.emboTypes?.join(', ')}
					</p>
				</td>
				<td className="sewing-column">
					<p className="regular-14  gray_dark_02 mb-0">
						Sewing completed:{item?.inHouseDevelopmentJourneyDetails?.sewingCompletedDate},{' '}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						By & Qty: {item?.inHouseDevelopmentJourneyDetails?.sewingCompletedByName},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.sewingQuantity} pcs
					</p>
				</td>
				<td className="wash-column">
					<p className="regular-14  gray_dark_02 mb-0">
						-Rec wash: {item?.inHouseDevelopmentJourneyDetails?.washReceivedDate}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						-{item?.inHouseDevelopmentJourneyDetails?.washTypes.join(', ')}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						-L={item?.inHouseDevelopmentJourneyDetails?.shrinkageLength}%, W=
						{item?.inHouseDevelopmentJourneyDetails?.shrinkageWidth}%
					</p>
				</td>
				<td className="finishing-and-pd-review-column">
					<p className="regular-14  gray_dark_02 mb-0">
						Finishing: {item?.inHouseDevelopmentJourneyDetails?.finishingDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.finishingByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						PD review: {item?.inHouseDevelopmentJourneyDetails?.pdReviewDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.pdReviewByName}
					</p>
				</td>
				<td className="qc-review-column">
					<p className="regular-14  gray_dark_02 mb-0">
						QC review: {item?.inHouseDevelopmentJourneyDetails?.qcReviewDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.qcReviewByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						Review status: {item?.inHouseDevelopmentJourneyDetails?.qcReviewStatus}
					</p>
				</td>
				<td className="tp-owner-review-column">
					<p className="regular-14  gray_dark_02 mb-0">
						- Reviewed: {item?.inHouseDevelopmentJourneyDetails?.tpOwnerReviewedDate},{' '}
						{item?.inHouseDevelopmentJourneyDetails?.tpOwnerReviewedByName}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						-{item?.inHouseDevelopmentJourneyDetails?.deliveredOnTimeComment}
					</p>
					<p className="regular-14  gray_dark_02 mb-0">
						{item?.inHouseDevelopmentJourneyDetails?.satisfactionComment}
					</p>
				</td>
				<td className="fabric-status-textfield-column text-field-column">
					<input
						type="text"
						placeholder="Fabric status"
						defaultValue={item?.inHouseDevelopmentJourneyDetails?.fabricStatus ?? ''}
						onBlur={(e) => handleFabricStatus(item, e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.currentTarget.blur();
						}}
						disabled={isUploadingFabric}
					/>
				</td>
				<td className="buyer-feedback-textfield-column text-field-column">
					<input
						type="text"
						placeholder="Buyer feedback"
						defaultValue={item?.inHouseDevelopmentJourneyDetails?.buyerFeedback ?? ''}
						onBlur={(e) => handleGetBuyerFeedback(item, e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.currentTarget.blur();
						}}
						disabled={isUploadingFeedbackLoading}
					/>
				</td>
				<td className="remarks-textfield-column text-field-column">
					<input
						type="text"
						placeholder="Remarks"
						defaultValue={item?.inHouseDevelopmentJourneyDetails?.remarks ?? ''}
						onBlur={(e) => handleGetRemarks(item, e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.currentTarget.blur();
						}}
						disabled={isUpdatingRemarks}
					/>
				</td>
			</tr>
		);
	};

	return (
		<div>
			<div className="list-view-table-container position-relative">
				<p
					className="semibold-14 text-underline mb-12 cursor-pointer d-inline-block"
					onClick={() =>
						window.open(
							`/sample/view/${listViewResponse?.[0]?.inHouseDevelopmentJourneyDetails?.requestId}`,
							'_blank'
						)
					}
				>
					{listViewResponse?.[0]?.inHouseDevelopmentJourneyDetails?.brandResponse?.name}
					<span>|</span>
					{listViewResponse?.[0]?.systemReferenceNumber}
					<span>|</span>
					{listViewResponse?.[0]?.collectionName}
				</p>
				<div className="journey-details-list-table">
					<table
						className="table with-border journey-details-table scroll-y-label scroll-x-label"
						ref={elementRef}
					>
						<thead>
							<tr>
								<th className="checkbox-column">
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="selectAll"
												name="selectAll"
												onChange={(e) => handleSelectAllSampleItem(e)}
												checked={listViewResponse?.data?.every((item) =>
													selectedSampleItem.includes(parseInt(item?.id))
												)}
											/>
											<label htmlFor="selectAll" />
										</div>
									</div>
								</th>
								<th className="image-column">Image</th>
								<th className="ref-column">Ref</th>
								<th className="style-details-column white-space-nowrap">Style details</th>
								<th className="brand-column">Brand</th>
								<th className="request-column">Request</th>
								<th className="white-space-nowrap">Send to PD & Rcv</th>
								<th className="white-space-nowrap">Planned vs Actual</th>
								<th>Last Status</th>
								<th className="white-space-nowrap">
									QC Lead time: <br /> Rcv by PD - QC approval
								</th>
								<th className="white-space-nowrap">
									Actual lead time: <br /> Send to PD - H/O to Owner
								</th>
								<th className="white-space-nowrap">
									Plan lead time: <br /> Send to PD - Plan date
								</th>
								<th className="white-space-nowrap">
									Required lead time: <br /> Send to PD - Required date
								</th>
								<th className="white-space-nowrap">Pending Issue</th>
								<th>Priority</th>
								<th>Graphics</th>
								<th>3D</th>
								<th className="white-space-nowrap">Pattern & Cutting complete</th>
								<th>Print</th>
								<th>Embroidery</th>
								<th>Sewing</th>
								<th>Wash</th>
								<th>Finishing & PD review</th>
								<th>QC review</th>
								<th className="white-space-nowrap">TP owner review</th>
								<th>Fabric status</th>
								<th>Buyer feedback</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							{listViewResponse?.map((item, idx) => renderSampleJourneyListRow(item, idx))}
						</tbody>
					</table>
				</div>
				<div className="scroll-table-buttons sample-journey-table-button">
					<button
						className="left"
						disabled={arrowDisable}
						onClick={() => handleHorizontalScroll(elementRef.current, 25, 100, -400)}
					>
						<LeftArrow />
					</button>
					&nbsp;&nbsp;
					<button
						className="right"
						disabled={rightArrowDisable}
						onClick={() => handleHorizontalScroll(elementRef.current, 25, 100, 400)}
					>
						<RightArrow />
					</button>
				</div>
			</div>
		</div>
	);
};
export default SampleJourneyList;
